
























import { Component, Model, Prop, Vue } from 'vue-property-decorator';
import StyledSelectDefaultView from '@/views/common/StyledSelectDefaultView.vue';
import SmoothShow from '@/views/common/SmoothShow.vue';

export interface StyledSelectData<T> {
  displayString: string;
  key: string | number;
  value: T;
}

@Component({
  components: {SmoothShow, StyledSelectDefaultView},
})
export default class StyledSelect<T> extends Vue {
  @Prop({required: true})
  private data!: Array<StyledSelectData<T>>;

  @Prop({required: false, default: false})
  private darkDisplay!: boolean;

  @Prop({required: false, default: false})
  private darkOption!: boolean;

  @Prop({required: false, default: 'StyledSelectDefaultView'})
  private optionComponent!: string;

  @Prop({required: false, default: null})
  private displayComponent!: string;

  @Prop({required: false, default: true})
  private autoWidth!: boolean;

  @Model('select')
  private readonly selected?: StyledSelectData<T>;

  get displayComponentName() {
    return this.displayComponent ?? this.optionComponent;
  }

  private showOptions: boolean = false;

  private select(value: StyledSelectData<T>) {
    this.showOptions = false;
    this.$emit('select', value.displayString, value.value);
  }

  get displayString(): string {
    return this.selected?.displayString ?? '';
  }

  get selectedValue(): T | null {
    return this.selected?.value ?? null;
  }

  get optionsStyle() {
    if (this.autoWidth) {
      return {visibility: this.showOptions ? 'visible' : 'hidden'};
    } else {
      return {};
    }
  }

  private toggleOptions(): void {
    this.showOptions = !this.showOptions;
  }

  private handleFocusChange() {
    this.showOptions = false;
  }
}
